export default __webpack_public_path__ + "static/media/background-5.f82e1e8a.jpeg";